import * as Types from "./Types";

export function setLanguage(language) {
  return {
    type: Types.LANGUAGE_SET,
    language
  };
}
